import { STATES } from '../../../constants';
import { selectors } from '../../../state';
import { STATE_NAME as MOVING_CENTER_FORM_STATE } from './form';
import { STATE_NAME as MOVING_CENTER_PREMIUM_STATE } from './companies';
import { STATE_NAME as MOVING_CENTER_DIY_STATE } from './diy';

const getMoveId = state => selectors.current.move(state).id(state);

export function getMovingCenterDataState(isPremium) {
  return isPremium ? MOVING_CENTER_PREMIUM_STATE : MOVING_CENTER_DIY_STATE;
}

export function defineMovingCenterRoles(Permission) {
  'ngInject';
  Permission.defineRole({
    name: 'hasMovingCenterData',
    // moveId is coming from a resolve on moving-center.config
    validation: (moveId, updStore) => {
      'ngInject';
      const state = updStore.getState();
      return selectors.movingCenter.hasData(moveId, state);
    },
    redirect: updStore => {
      'ngInject';
      return wasNegated => {
        const state = updStore.getState();

        return wasNegated
          ? currentlyInMoveCenterChildState(state)
            ? STATES.DASHBOARD
            : getMovingCenterDataState(
                selectors.movingCenter.isPremiumKind(getMoveId(state), state)
              )
          : MOVING_CENTER_FORM_STATE;
      };
    },
  });

  Permission.defineRole({
    name: 'isPremiumMovingCenterKind',
    validation: updStore => {
      'ngInject';
      const state = updStore.getState();
      return selectors.movingCenter.isPremiumKind(getMoveId(state), state);
    },
    redirect: updStore => {
      'ngInject';
      return wasNegated => {
        return currentlyInMoveCenterChildState(updStore.getState())
          ? STATES.DASHBOARD
          : getMovingCenterDataState(wasNegated);
      };
    },
  });
}

function currentlyInMoveCenterChildState(state) {
  return (
    selectors.router.currentName(state).indexOf(STATES.STEP_MOVING_CENTER) === 0
  );
}
